var _defs, _rect, _g, _g2, _g3, _g4, _circle, _path, _path2, _path3, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFishiesbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .fishies_before_svg__cls-11,.fishies_before_svg__cls-17,.fishies_before_svg__cls-18,.fishies_before_svg__cls-28,.fishies_before_svg__cls-32,.fishies_before_svg__cls-9{stroke:#343a50}.fishies_before_svg__cls-17,.fishies_before_svg__cls-18,.fishies_before_svg__cls-28,.fishies_before_svg__cls-32,.fishies_before_svg__cls-9{stroke-miterlimit:10}.fishies_before_svg__cls-4{fill:#343a50}.fishies_before_svg__cls-5{fill:#fff;opacity:.32}.fishies_before_svg__cls-7{fill:#eb9a6b}.fishies_before_svg__cls-9{fill:#7fc3ca}.fishies_before_svg__cls-11,.fishies_before_svg__cls-9{stroke-width:2px}.fishies_before_svg__cls-10{fill:#d88b64}.fishies_before_svg__cls-11,.fishies_before_svg__cls-16{fill:#dedede}.fishies_before_svg__cls-11{stroke-linecap:round;stroke-linejoin:round}.fishies_before_svg__cls-17{fill:#b01928}.fishies_before_svg__cls-17,.fishies_before_svg__cls-18,.fishies_before_svg__cls-28{stroke-width:3px}.fishies_before_svg__cls-18{fill:#525254}.fishies_before_svg__cls-25{fill:#969799}.fishies_before_svg__cls-28{fill:#f9cab8}.fishies_before_svg__cls-32{fill:#464655;stroke-width:3.6px}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Fish_n_Tipps_Vorher",
    "data-name": "Fish'n'Tipps_Vorher"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "fishies_before_svg__Himmel",
    width: 1259.99,
    height: 618.01,
    x: -0.99,
    y: -1,
    fill: "#a5d1d6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Wiese"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9bf5c",
    points: "-1 1081 -1 672.92 1259 660.58 1259 1081 -1 1081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 661.59V1080H0V673.91l1258-12.32m2-2h-2L0 671.91h-2V1082h1262V659.57z",
    className: "fishies_before_svg__cls-4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.32 98.17C86.81 85.26 100.71 76 117.12 76c16.2 0 30 9 35.63 21.65a29.7 29.7 0 017.25-1c14.81 0 26.81 10.7 26.81 23.9s-12 23.9-26.81 23.9H90.31c-14.8 0-26.8-10.7-26.8-23.9 0-10.33 7.49-19.07 17.81-22.38zM969.65 55.73c9.23-21.68 32.57-37.17 60.13-37.17 27.22 0 50.39 15.09 59.85 36.36a49.65 49.65 0 0112.18-1.67c24.87 0 45 18 45 40.13s-20.15 40.14-45 40.14h-117c-24.86 0-45-18-45-40.14-.07-17.38 12.45-32.09 29.84-37.65zM501 83.45c-6-14-21.08-24.06-38.93-24.06-17.62 0-32.62 9.77-38.74 23.54a31.83 31.83 0 00-7.89-1.09c-16.1 0-29.15 11.64-29.15 26s13.05 26 29.15 26h75.78c16.1 0 29.15-11.64 29.15-26-.05-11.29-8.16-20.79-19.37-24.39zM715.51 111.44c5.19-12.19 18.3-20.89 33.79-20.89 15.3 0 28.32 8.48 33.63 20.44a27.49 27.49 0 016.85-.95c14 0 25.3 10.1 25.3 22.56s-11.33 22.55-25.3 22.55H724c-14 0-25.3-10.09-25.3-22.55 0-9.79 7.04-18.04 16.81-21.16z",
    className: "fishies_before_svg__cls-5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Weg"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "767.82 1081 969.75 675.06 -1 674.91 -1 613.93 1258.98 616.42 1259.99 673.62 1259 1081 767.82 1081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 614.93l1258 2.49 1 56.22-1 406.36H769.44l201.92-405.94L0 673.91v-59m-2-2v63h2l968.13.15-200.48 403-1.44 2.89H1260v-2l1-406.36-1-56.25v-2h-2L0 612.93z",
    className: "fishies_before_svg__cls-4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Haus"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.87 616.42 1.01 182.7 1259.06 182.7 1259.06 616.42 2.87 616.42",
    className: "fishies_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.06 183.71v431.71H3.87L2 183.71h1256.06m2-2H0l1.87 435.71h1258.19V181.7z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 359.33,
    height: 429.91,
    x: 4.48,
    y: 184.02,
    fill: "#bc7b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.81 185v427.93H5.48V185h357.33m2-2H3.48v431.93h361.33V183z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 199.74,
    height: 325.05,
    x: 40.19,
    y: 216.67,
    className: "fishies_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.67,
    height: 323.05,
    x: 129.23,
    y: 217.67,
    className: "fishies_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.9 218.67v321.05h-19.67V218.67h19.67m2-2h-23.67v325.05h23.67V216.67z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 197.91,
    height: 21.67,
    x: 41.19,
    y: 368.36,
    className: "fishies_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1 369.36V389H42.19v-19.64H238.1m2-2H40.19V391H240.1v-23.64z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 199.74,
    height: 325.05,
    x: 848.12,
    y: 216.67,
    className: "fishies_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "937.16 541.72 937.16 390.03 847.61 390.03 847.61 368.36 937.16 368.36 937.16 216.66 958.83 216.66 958.83 368.36 1047.85 368.36 1047.85 390.03 958.83 390.03 958.83 541.72 937.16 541.72",
    className: "fishies_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.83 217.66v151.7h89V389h-89v151.72h-19.67V389h-89.55v-19.64h89.55v-151.7h19.67m2-2h-23.67v151.7h-89.55V391h89.55v151.72h23.67V391h89v-23.64h-89v-151.7z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180.69,
    height: 325.05,
    x: 1078.33,
    y: 216.67,
    className: "fishies_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1167.37 541.72 1167.37 390.03 1078.34 390.19 1078.3 368.52 1167.37 368.37 1167.37 216.66 1189.03 216.66 1189.03 368.33 1258.98 368.21 1259.02 389.88 1189.03 390 1189.03 541.72 1167.37 541.72",
    className: "fishies_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188 217.66v151.67h2l67.94-.12v19.67l-68 .11h-2v151.73h-19.66V389h-2l-87 .15v-19.67l87.07-.15h2V217.66H1188m2-2h-23.66v151.71l-89.07.15v23.67l89-.15v151.68H1190V391l70-.12v-23.66l-70 .12V215.66z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 325.95,
    height: 377.38,
    x: 473.9,
    y: 239.04,
    className: "fishies_before_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.85 240v375.42h-324V240h324m2-2h-328v379.42h328V238z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260.47,
    height: 354.49,
    x: 504.42,
    y: 261.93,
    className: "fishies_before_svg__cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.89 262.93v352.49H505.42V262.93h258.47m2-2H503.42v356.49h262.47V260.93z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "719.15 616.07 554.6 616.4 554.6 283.23 719.15 283.23 719.15 616.07",
    className: "fishies_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.43 616.42 631.43 530.18 554.13 530.18 554.13 519.3 631.43 519.3 631.43 442.35 554.13 442.35 554.13 431.47 631.43 431.47 631.43 356.91 554.13 356.91 554.13 346.02 631.43 346.02 631.43 283.22 642.32 283.22 642.32 346.02 719.38 346.02 719.38 356.91 642.32 356.91 642.32 431.47 719.06 431.53 719.06 442.42 642.32 442.35 642.32 519.3 719.13 519.3 719.14 530.18 642.32 530.18 642.32 616.42 631.43 616.42",
    className: "fishies_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.32 284.22V347h77.06v8.88h-77.06v76.56h2l74.74.06v8.89l-74.74-.07h-2v78.98h76.81v8.88h-76.81v86.24h-8.89v-86.24h-77.3v-8.87h77.3v-78.96h-77.3v-8.88h77.3v-76.56h-77.3V347h77.3v-62.78h8.89m2-2h-12.89V345h-77.3v12.88h77.3v72.56h-77.3v12.88h77.3v74.98h-77.3v12.88h77.3v86.24h12.89v-86.24h76.83V518.3h-76.83v-74.95l76.74.07v-12.89l-76.74-.06v-72.56h77.06V345h-77.06v-62.78z",
    className: "fishies_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.9,
    x2: 503.42,
    y1: 238.04,
    y2: 260.93,
    className: "fishies_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 798.89,
    x2: 763.66,
    y1: 240.06,
    y2: 262.34,
    className: "fishies_before_svg__cls-11"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Baum"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 781.28,
    cy: 158.7,
    r: 197.52,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M611.15 162.47C611.15 53.38 699.59-35 808.68-35q6.78 0 13.44.46a198.4 198.4 0 00-40.84-4.24c-109.09 0-197.53 88.44-197.53 197.53 0 104.57 81.27 190.14 184.09 197.06-89.49-18.87-156.69-98.25-156.69-193.34z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M754.94 728.69a8.91 8.91 0 01-6.43-2.73 8.18 8.18 0 01-2.28-6.11l16.92-243.28-50.6-59.77a3.22 3.22 0 01-.51-3.52 3.35 3.35 0 015-1.44l48.46 31.47 12.32-177.22-36-35.65a2.12 2.12 0 01-.49-2.33 2.18 2.18 0 012-1.37 2.21 2.21 0 011 .22l35.12 16.78 4.8-69.06.28-5.4a8.34 8.34 0 0116.63-.3l3.26 43.83 34.76-18.15h.15a5.07 5.07 0 01.86-.07 4.55 4.55 0 014.36 3.17 4.45 4.45 0 01-1.61 5.08l-35.6 25.38 31.71 491.38a8.19 8.19 0 01-2.15 6.27 8.88 8.88 0 01-6.55 2.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M792.76 162.47a7 7 0 017.29 6.6l3.38 45.33 36-18.78a4.2 4.2 0 01.69-.06 3.59 3.59 0 012.15 6.45l-36 25.69 31.74 491.93a7.55 7.55 0 01-7.7 8.06h-75.3a7.56 7.56 0 01-7.71-7.79l16.94-243.67-50.86-60.08a2.36 2.36 0 013.14-3.47l49.89 32.4 12.4-179.38-36.37-36a1.16 1.16 0 01.82-2 1.27 1.27 0 01.52.12l36.45 17.41 4.9-70.52.29-5.41a7.06 7.06 0 017.34-6.87m0-2a9.1 9.1 0 00-9.34 8.76l-.28 5.42-4.7 67.55-33.79-16.14a3.28 3.28 0 00-1.39-.32 3.15 3.15 0 00-2.93 2 3.08 3.08 0 00.71 3.42l35.71 35.33-12.17 175.1-47-30.55a4.35 4.35 0 00-6.41 1.86 4.2 4.2 0 00.66 4.58l50.33 59.46-16.93 242.86a9.2 9.2 0 002.56 6.88 9.86 9.86 0 007.15 3.05h75.3a9.85 9.85 0 007.28-3.18 9.11 9.11 0 002.41-7l-31.66-490.8 35.12-25a5.49 5.49 0 002-6.22 5.6 5.6 0 00-5.3-3.86 6 6 0 00-1 .09h-.31l-.27.15-33.28 17.37-3.14-42.3a9.06 9.06 0 00-9.29-8.45z",
    className: "fishies_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M803.7 218.87L843.24 198a3.54 3.54 0 00-3.85-1.91l-36 19zM787.46 249.84l5.12-74.93.28-5.48a7 7 0 013.62-6c-4.24-2.34-10.74-.28-11.06 6l-.29 5.48-4.88 71.45zM754.67 717.92l31.58-452.36L752 231.62l-8.17-3.9a1.16 1.16 0 00-1.34 1.86l36.37 36-13.58 194.71-18 259.61a7.56 7.56 0 007.71 7.79h7.45c-4.44 0-7.98-5.53-7.77-9.77z",
    className: "fishies_before_svg__cls-16"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1239 669.22l59.4-27.22-49.49-46.57c-1 .5-72-13.65-73.06-13.15a48.94 48.94 0 00-7 4.15l-176-4.16-18.07 6.53c-1.38-.67-4.12 4.18-5.5 3.51-1-.5-.72 5.07-1.76 4.56l-54.1 50.91 58 26.28c15-3.92 18.51-13.2 31.11-18.29s34.27-6 49.23-9.9h86.35c15.12 2.94 42.11-1.09 57.54 2.46 19.35 4.47 26.94 16.6 43.35 20.89z",
    className: "fishies_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.23 642.94h-102.87c-57.33 0-103.8 32.71-103.8 73.06l-52 9.1H1321l-58-9.1c0-40.35-46.44-73.06-103.77-73.06zm92 71.51H964.55v-1.4c0-35.74 41.17-64.72 92-64.72h102.82c50.79 0 92 29 92 64.72z",
    className: "fishies_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.74,
    height: 40.9,
    x: 1216.99,
    y: 692.34,
    className: "fishies_before_svg__cls-18",
    transform: "rotate(-29.97 1221.091 712.858)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.9,
    height: 7.74,
    x: 1234.32,
    y: 708.92,
    className: "fishies_before_svg__cls-18",
    transform: "rotate(-60.02 1254.81 712.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239 796.79a58.54 58.54 0 1158.53-58.54 58.61 58.61 0 01-58.53 58.54zm0-105.46a46.92 46.92 0 1046.92 46.92 47 47 0 00-46.92-46.92z",
    className: "fishies_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 117.65,
    height: 79.5,
    x: 797.37,
    y: 990.72,
    fill: "#404040",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 15.49
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba1e2c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M887.23 715.52c-4.47-8-11.09-11.8-16.7-14.94 0 0-18.3-10.24-54-3.51a9.5 9.5 0 00-4.84 2.19c-5.13 4.68-2.63 14.93-2.2 16.7 2.94 12 12.75 19.11 19.78 24.17a70.17 70.17 0 0020.65 10.1c5.78 1.73 11.07 3.32 18 2.64 4.39-.43 15.52-1.52 21.09-10.11 6.99-10.87-.53-25-1.78-27.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2232",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1343.59 740.89c0-7.29-104.42-13.2-233.23-13.2s-233.24 5.91-233.24 13.2l-104.35 61h677.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.44 799c-24.45-17.37-164.6-30.68-333.85-30.68-178.7 0-325 14.85-336.82 33.63a35.22 35.22 0 00-15.6 29.27v90h.11c4.63 17.47 161.12 31.5 353.5 31.5s348.87-14 353.5-31.5h.11v-90a35.26 35.26 0 00-20.95-32.22z",
    className: "fishies_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1107.82,
    x2: 1107.79,
    y1: 580.23,
    y2: 613.51,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 10.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 284.07,
    height: 112.06,
    x: 964.8,
    y: 867.1,
    fill: "#7d7e82",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 15.49
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9ad",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1470.35 922.15a15.49 15.49 0 00-6-12.17v11.18h-.11c-4.63 17.47-161.13 31.5-353.5 31.5s-348.87-14-353.5-31.5h-.11V910a15.44 15.44 0 00-5.89 12.11v54.09a14.89 14.89 0 00.47 3.67 4.55 4.55 0 00-.47 2c0 21.27 161 38.52 359.53 38.52s359.54-17.25 359.54-38.52a4.55 4.55 0 00-.47-2 15.38 15.38 0 00.47-3.67z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 91.62,
    height: 24.39,
    x: 1061.99,
    y: 601.32,
    className: "fishies_before_svg__cls-18",
    rx: 8.98
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "895.78 729.94 1289.71 735.75 1336.87 727.6 1292.96 618.32 1230.91 583.93 1167.34 579.76 1031.77 577.73 968.38 594.37 910.75 653.27 895.78 729.94",
    className: "fishies_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.57 575.13h-151.86a153.24 153.24 0 00-153.24 153.24v10h458.34v-10a153.24 153.24 0 00-153.24-153.24zm135.88 150H899.17v-2.93a135.74 135.74 0 01135.75-135.74h151.79a135.74 135.74 0 01135.74 135.74z",
    className: "fishies_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 272.87,
    height: 4.83,
    x: 971.39,
    y: 884.96,
    className: "fishies_before_svg__cls-25",
    rx: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 272.87,
    height: 4.83,
    x: 971.36,
    y: 894.95,
    className: "fishies_before_svg__cls-25",
    rx: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 272.87,
    height: 4.83,
    x: 971.4,
    y: 904.95,
    className: "fishies_before_svg__cls-25",
    rx: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 272.87,
    height: 4.83,
    x: 971.37,
    y: 914.95,
    className: "fishies_before_svg__cls-25",
    rx: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 272.87,
    height: 4.83,
    x: 971.41,
    y: 924.94,
    className: "fishies_before_svg__cls-25",
    rx: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 272.87,
    height: 4.83,
    x: 971.39,
    y: 934.94,
    className: "fishies_before_svg__cls-25",
    rx: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88.47,
    height: 47.72,
    x: 767.72,
    y: 815.3,
    fill: "#fcb042",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 15.49
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Frau"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Arm_Hand",
    "data-name": "Arm&Hand"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f9cab8",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "569.34 1185.16 716.25 948.13 646.41 916.36 498.51 1143.11 569.34 1185.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770 947.76c-19 38.76-47.66 67.51-76.63 80.65-20.78 9.43-41.74 10.81-59.48 2.1-42.47-20.86-50.39-91.74-17.68-158.31s93.64-103.62 136.11-82.75 50.33 91.74 17.68 158.31z",
    className: "fishies_before_svg__cls-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Handy"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169.12,
    height: 292.24,
    x: 565.21,
    y: 738.34,
    fill: "#707484",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 26.92,
    transform: "rotate(26.16 649.84 884.583)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 136.26,
    height: 235.47,
    x: 585.69,
    y: 758.49,
    fill: "#62aedb",
    rx: 21.69,
    transform: "rotate(26.16 653.873 876.365)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590.16,
    cy: 997.15,
    r: 9.87,
    fill: "#464655",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.8,
    height: 7.31,
    x: 702.64,
    y: 761.67,
    className: "fishies_before_svg__cls-32",
    rx: 3.66,
    transform: "rotate(26.16 717.607 765.454)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 696.78,
    cy: 755.13,
    r: 3.73,
    className: "fishies_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 136.22,
    height: 50.48,
    x: 605.03,
    y: 811.69,
    fill: "#468abd",
    transform: "rotate(26.16 673.206 837.057)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 51.22,
    transform: "rotate(25.8 -1488.001 1735.796)"
  }, "\r\n       S", /*#__PURE__*/React.createElement("tspan", {
    x: 25.25,
    y: 0,
    letterSpacing: "-.08em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.86,
    y: 0,
    letterSpacing: "-.03em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 76.77,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("path", {
    fill: "#ea5757",
    d: "M656.62 869.78a29.55 29.55 0 00-41.9 32.85l-8.39 69.52L656.22 923a29.55 29.55 0 00.4-53.24zm-15.29 31.12a8 8 0 1110.67-3.64 8 8 0 01-10.67 3.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f9cab8",
    stroke: "#343a50",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M673.14 1035c-2.3-12.5 5.07-35.7 2.75-48.19-4.6-24.77-6.4-50.23-13.88-74.28a24.5 24.5 0 01-1-7.29c0-3.14 0-6.59 2.43-9.37a10.84 10.84 0 019.72-3.47c4.12.72 6.71 4.13 10.41 9a35.24 35.24 0 012.78 4.17c2.42 4.32 2.56 6.89 4.65 15.51.2.82 1.36 4.86 3.68 12.95 1.17 4.1 1.79 6.18 3.12 7.64 3.41 3.72 8.85 3.7 11.11 3.81 7.81.39 43-70.8 43-73.41l13.68-26.74 13.23-26.94 5.51 10 3.1 14.61"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fishies_before_svg__Frau-2",
    "data-name": "Frau"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.61 638.66v36L-68 661.49c-5.58-.08-15-2.71-26.08.91-16.31 5.37-28.21 21.12-31.12 40.44L-37 724.9l140.91 39.21S334.26 781.26 337.94 780 583 715.13 583 715.13a71.43 71.43 0 00-6.13-29.44c-3.65-8.13-7.33-16.32-15.93-19.61-6.45-2.46-11.52-3.55-16.43-3.58l-253.15 7.26-.81-31.1",
    className: "fishies_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#926652",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M627.12 549.67c1.27-8.11-5.72-14.52-14.71-25.73 0 0-5.68-7.09-27.57-44.11-13.2-22.34-5.85-41.22 0-101.09 1.68-17.17 3-54.94 5.52-130.5 1.62-47.82 2.42-71.73 1.84-79C585.74 89.11 543.11 30.4 526 7.46c-13.18-17.7-62.6-80.59-152.56-117.64-75.34-31-140.73-28.12-183.8-25.73-32 1.77-74.43 4.08-125 23.89C33.24-99.69-53.34-60.41-108.09 35c-6.44 11.22-50.94 91.08-44.11 191.15 2 28.79 9.29 75.62 18.38 117.63 11.78 54.47 21.72 78.7 12.86 115.8-4.78 20-12.11 50.72-36.76 64.33-12.91 7.13-27.37 7.8-31.24 18.38-3.32 9.06 1.81 21 9.19 27.57 7.12 6.3 15.91 6.71 18.38 7.35 46.54 12.07 84.29 23.26 128.08 31.69 40.83 7.86 35.17 6.73 74.1 14.26 12.71 2.46 55.66 10.49 115.79 14.71 54.09 3.79 122.13 8.17 207.7-5.52a371.92 371.92 0 0038.49-8c14.65-4.07 22.79-6.13 37.75-10.06 14.41-3.78 24.71-6.65 32.2-7.66 0 0 48.15-7.8 128.67-36.76 7.24-2.58 23.95-8.81 25.73-20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a51",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M-125.25 703.5c24.38 5.29 82.37 1.52 126.52 9.76 98.4 18.36 147.6 27.54 199.43 29.41 59.48 2.13 102.12-3.92 184.72-15.63 86.58-12.28 123.18-17.66 153.46-26.59 2.57-.76 26.5-7.6 34-10.92 10.16-4.52 10.87 32.17 10.87 34.7L583 780.1l-3.68 99.5-73.08 244.45h-562l-55.87-239.36-14.61-173.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.29 822.93a985.771 985.771 0 00-8.58 62.85 985.31 985.31 0 00-4.9 74.38 988.27 988.27 0 008.58 160.52h74.74q-3.33-16.18-6.12-33.08a851.53 851.53 0 01-8.58-203.41L510.28 890",
    className: "fishies_before_svg__cls-28"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishiesbefore);
export default __webpack_public_path__ + "static/media/fishies.before.4a73b08e.svg";
export { ForwardRef as ReactComponent };